import { JsonObject } from 'ta-json';
import { GetAllRetailers_allRetailers_edges_node_retailerOptions_configuratorOptions_font } from '@src/app/generated/GetAllRetailers';
import { PortalAsset } from '@src/app/model/portal-asset';
import { FontInput } from '@src/app/generated/globalTypes';
import { Font } from '@ess/jg-rule-executor';

/**
 * Font
 */
@JsonObject()
export class PortalFont extends Font {
  static fromGql(gql: GetAllRetailers_allRetailers_edges_node_retailerOptions_configuratorOptions_font): PortalFont {
    return new PortalFont(
      gql.regularFontAsset ? PortalAsset.fromGql(gql.regularFontAsset) : undefined,
      gql.boldFontAsset ? PortalAsset.fromGql(gql.boldFontAsset) : undefined,
      gql.italicFontAsset ? PortalAsset.fromGql(gql.italicFontAsset) : undefined,
      gql.mediumFontAsset ? PortalAsset.fromGql(gql.mediumFontAsset) : undefined
    );
  }

  toGqlInput(): FontInput {
    return {
      regularFontAsset: (this.regularFontAsset as PortalAsset)?.toGqlInput(),
      boldFontAsset: (this.boldFontAsset as PortalAsset)?.toGqlInput(),
      italicFontAsset: (this.italicFontAsset as PortalAsset)?.toGqlInput(),
      mediumFontAsset: (this.mediumFontAsset as PortalAsset)?.toGqlInput(),
    };
  }
}
